import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MFOrderItem } from "Pages/MutualFundOrders/MutualFunds/useMFOrders";

interface MFOrdersState {
  portfolios: MFOrderItem[];
}

const initialState: MFOrdersState = {
  portfolios: [],
};

const mfOrdersSlice = createSlice({
  name: "mfOrders",
  initialState,
  reducers: {
    setMFPortfolios: (state, action: PayloadAction<MFOrderItem[]>) => {
      state.portfolios = action.payload;
    },
    clearMFPortfolios: (state) => {
      state.portfolios = [];
    },
  },
});

export const { setMFPortfolios, clearMFPortfolios } = mfOrdersSlice.actions;

export default mfOrdersSlice.reducer;
